// extracted by mini-css-extract-plugin
export default {"item":"InvoicesList_item__85zzK","invoiceNumber":"InvoicesList_invoiceNumber__xACKM","date":"InvoicesList_date__rC7Sw","icon":"InvoicesList_icon__E2RlA"};